import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header/Header';
import { useSelector } from 'react-redux';

const Home = () => {

    const projectsData = useSelector(state => state.projects)

    return (
        <Homepage>
            <Header projectsData={projectsData} />
        </Homepage>
    )
}

const Homepage = styled.div`
    background-color: aqua;
    height: 100vh;
    width: 100%;
    overflow-y: hidden;
`;

export default Home
